import { Box } from "@material-ui/core";
import React from "react";
import ReactList from "react-list";
import { IFlightListData } from "redmond";
import { RecommendedFlightInfo } from "../RecommendedFlightInfo";
import { RecommendedFlightInfoProps } from "../RecommendedFlightInfo/component";
import { FlightSummaryPanel } from "../../../FlightShopHeader/FlightSummaryPanel";
import { SelectedPackagePricingCard } from "../../../FlightShopHeader/SelectedPackagePricingCard";
import { FlightShopHeader } from "../../../FlightShopHeader";
import { FlightListInfo } from "../FlightListInfo";

interface MobileFlightListProps
  extends Omit<RecommendedFlightInfoProps, "flight"> {
  faresToShow: IFlightListData[];
  flights: any;
  selectedFareId: string;
  isOutgoing: boolean;
  outgoingRecommendedFlight: any;
  returnRecommendedFlight: IFlightListData | null | undefined;
}

export const MobileFlightList = ({
  isOutgoing,
  faresToShow,
  flights,
  selectedFareId,
  outgoingRecommendedFlight,
  returnRecommendedFlight,
  expandedFlight,
  maxPriceFilter,
  packagesByOutboundFareSlice,
  packagesByReturnFareSlice,
  fareClassFilter,
  isAgentPortal,
  departureDate,
  returnDate,
  hotelShopDateRange,
  airports,
  rewardsKey,
  isTripDetailsLoading,
  openMobileFlightDetailsModal,
  largestValueAccount,
  expandedFareDetails,
  handleClickAlgomerchTag,
  setOpenModal,
  handleFareSelect,
  setClickedFareId,
  setExpandedFlight,
  handleSliceSelect,
  setOpenMobileFlightDetailsModal,
}: MobileFlightListProps) => {
  const renderListItem = React.useCallback(
    (index: number, key: number | string) => {
      const currentFare = faresToShow[index];

      const { slice: flightSliceId } = currentFare;
      const flightSlice = flights?.slices[flightSliceId];
      const isListView = !flightSlice?.domestic;
      if (
        !flightSlice ||
        flightSliceId === outgoingRecommendedFlight?.slice ||
        flightSliceId === returnRecommendedFlight?.slice
      ) {
        // itemRenderer does not allow for returning of undefined/null
        return (
          <Box
            display="none"
            // key={`${fare.example?.fare || fare.id}-none`}
          />
        );
      }
      const selectedFare =
        currentFare.fares.find(
          (fare: any) => fare.example?.fare === selectedFareId
        ) || currentFare.fares[0];

      return (
        <FlightListInfo
          key={key}
          selectedFare={selectedFare}
          showListView={isListView}
          slice={flightSlice}
          flight={currentFare}
          index={index}
          flights={flights}
          selectedFareId={selectedFareId}
          expandedFlight={expandedFlight}
          fareClassFilter={fareClassFilter}
          maxPriceFilter={maxPriceFilter}
          isOutgoing={isOutgoing}
          packagesByOutboundFareSlice={packagesByOutboundFareSlice}
          packagesByReturnFareSlice={packagesByReturnFareSlice}
          departureDate={departureDate}
          returnDate={returnDate}
          hotelShopDateRange={hotelShopDateRange}
          isTripDetailsLoading={isTripDetailsLoading}
          openMobileFlightDetailsModal={openMobileFlightDetailsModal}
          airports={airports}
          rewardsKey={rewardsKey}
          isAgentPortal={isAgentPortal}
          largestValueAccount={largestValueAccount}
          expandedFareDetails={expandedFareDetails}
          handleClickAlgomerchTag={handleClickAlgomerchTag}
          setOpenModal={setOpenModal}
          handleSliceSelect={handleSliceSelect}
          setClickedFareId={setClickedFareId}
          setExpandedFlight={setExpandedFlight}
          handleFareSelect={handleFareSelect}
          setOpenMobileFlightDetailsModal={setOpenMobileFlightDetailsModal}
        />
      );
    },
    [
      faresToShow,
      flights,
      selectedFareId,
      expandedFlight,
      fareClassFilter,
      maxPriceFilter,
      isOutgoing,
      packagesByOutboundFareSlice,
      packagesByReturnFareSlice,
      departureDate,
      returnDate,
      hotelShopDateRange,
      isTripDetailsLoading,
      openMobileFlightDetailsModal,
      airports,
      rewardsKey,
      isAgentPortal,
      largestValueAccount,
      expandedFareDetails,
    ]
  );

  return (
    <div className="availability-list">
      <FlightSummaryPanel />
      <Box className="selected-package-pricing-card-wrapper">
        <SelectedPackagePricingCard isMobile />
      </Box>
      <FlightShopHeader isMobile />

      <RecommendedFlightInfo
        flight={
          isOutgoing ? outgoingRecommendedFlight : returnRecommendedFlight
        }
        flights={flights}
        selectedFareId={selectedFareId}
        expandedFlight={expandedFlight}
        maxPriceFilter={maxPriceFilter}
        isOutgoing={isOutgoing}
        packagesByOutboundFareSlice={packagesByOutboundFareSlice}
        packagesByReturnFareSlice={packagesByReturnFareSlice}
        fareClassFilter={fareClassFilter}
        isAgentPortal={isAgentPortal}
        departureDate={departureDate}
        returnDate={returnDate}
        hotelShopDateRange={hotelShopDateRange}
        airports={airports}
        rewardsKey={rewardsKey}
        isTripDetailsLoading={!!isTripDetailsLoading}
        openMobileFlightDetailsModal={!!openMobileFlightDetailsModal}
        largestValueAccount={largestValueAccount}
        expandedFareDetails={expandedFareDetails}
        handleClickAlgomerchTag={handleClickAlgomerchTag}
        setOpenModal={setOpenModal}
        handleFareSelect={handleFareSelect}
        setClickedFareId={setClickedFareId}
        setExpandedFlight={setExpandedFlight}
        handleSliceSelect={handleSliceSelect}
        setOpenMobileFlightDetailsModal={setOpenMobileFlightDetailsModal}
      />
      <ReactList
        itemRenderer={renderListItem}
        length={faresToShow.length}
        type="variable"
      />
    </div>
  );
};
